const GuardiaoStatusEnum = {
    NAO_INFORMADO: "não informado",
    ONLINE: "online",
    ONLINE_SEM_MODEM: "online_sem_modem", 
    OFFLINE: "offline",
    SINCRONIZANDO: "sincronizando",

    canShowAmplifiers: function(status) {
        return status === this.ONLINE
    }
};

export default GuardiaoStatusEnum;